<template>
  <ModalDialog
    ref="dialog"
    :title="title"
    :icon="icon"
    :showFooter="false">

    <h2 class="text-center">{{message}}</h2>
    <div style="width: 100%;">
      <Spinner />
    </div>
  </ModalDialog>
</template>

<script>
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'

export default {
  name: "ProcessingDialog",
  mixins: [
    modalDialog
  ],
  components: {
    ModalDialog
  },
  props: {
    title: {
      type: String,
      default: "Processing"
    },
    icon: String,
    message: String
  },
  data() {
    return {
    }
  },
  mounted() {
  },
  computed: {
  },
  methods: {
    show(params) {
      return modalDialog.methods.show.call(this, params)
    },
    onClosed() {
      this.modalClosed(false)
    }
  }
}
</script>